import { useDeviceType } from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';
import cn from 'clsx';

import * as Dialog from '@radix-ui/react-dialog';

interface IModalProps {
  isOpen: boolean;
  onClose: () => void;
  type?: 'window' | 'curtain';
  children?: React.ReactNode;
  header?: React.ReactNode;
  fullScreen?: boolean;
}

export const Modal: React.FC<IModalProps> = ({ isOpen, onClose, type = 'curtain', fullScreen, children, header }) => {
  const deviceType = useDeviceType();

  return (
    <Dialog.Root open={isOpen}>
      <Dialog.Portal>
        <Dialog.Overlay
          className={cn(styles['dialog-overlay'], { [styles.open]: isOpen }, { [styles.closed]: !isOpen })}
        />
        <Dialog.Content
          className={cn(
            styles.root,
            styles[deviceType],
            styles[type],
            { [styles['full-screen']]: fullScreen },
            { [styles.open]: isOpen },
            { [styles.closed]: !isOpen },
          )}
        >
          {!header && (
            <Dialog.Close className={styles['close-button']} onClick={onClose}>
              <IconActionClose12 color="icon-main-default" />
            </Dialog.Close>
          )}

          {header && (
            <Dialog.Title className={cn(styles.header, styles[deviceType])}>
              <div className={styles['header-content']}>
                {header}

                <Dialog.Close className={cn(styles['close-button'], styles['with-title'])} onClick={onClose}>
                  <IconActionClose12 color="icon-main-default" />
                </Dialog.Close>
              </div>
            </Dialog.Title>
          )}
          <div className={styles.content}>{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

Modal.displayName = 'Modal';
